import React, { useState } from "react";
import { resolveImage } from "@/lib/api";

// Shows a tiny blurred preview instantly, then fades the full photo in once loaded.
export const BlurImage = ({ src, w, className = "", wrapperClassName = "", ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const isRemote = /^https?:\/\//.test(src || "");
  return (
    <span className={`block relative overflow-hidden ${wrapperClassName}`}>
      {!isRemote && !loaded && (
        <img
          src={resolveImage(src, { blur: true })}
          alt=""
          aria-hidden="true"
          className={`absolute inset-0 w-full h-full scale-105 blur-md ${className}`}
          data-testid="blur-placeholder"
        />
      )}
      <img
        src={resolveImage(src, { w })}
        onLoad={() => setLoaded(true)}
        ref={(el) => { if (el && el.complete && el.naturalWidth && !loaded) setLoaded(true); }}
        className={`relative w-full h-full transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"} ${className}`}
        {...rest}
      />
    </span>
  );
};
